import { render } from "./IconXMark.vue?vue&type=template&id=3e1ba446"
const script = {}
script.render = render

export default script